import { Button } from "@mui/material";
import { ConfirmationModal } from "@qubit/autoparts";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function SkipMovementButton({
  skipMove,
  inventoryActionsEnabled
}: {
  skipMove: () => void | Promise<void>;
  inventoryActionsEnabled: boolean;
}) {
  const { t } = useTranslation();

  const [isSkipMoveModalOpen, setIsSkipMoveModalOpen] = useState(false);

  return (
    <>
      <Button
        size="large"
        onClick={() => setIsSkipMoveModalOpen(true)}
        disabled={!inventoryActionsEnabled}
        sx={{ fontWeight: "normal" }}
        color="secondary"
      >
        {t("skip move")}
      </Button>

      <ConfirmationModal
        isOpen={isSkipMoveModalOpen}
        confirmCb={async () => {
          await skipMove();
          setIsSkipMoveModalOpen(false);
        }}
        closeCb={() => setIsSkipMoveModalOpen(false)}
        modalTitle={t("are you sure you want to skip move")}
        labelledById="skip-move-modal-title"
      />
    </>
  );
}
